export default "__VITE_ASSET__BaH849oa__"